import { Gutter } from 'antd/es/grid/row';

import { User } from 'types/auth';
import { Filters, SortOrders } from 'types/filters';

import { TranslationKey } from '../types/i18next';
import { AppModules, ClientTiers } from './enums';

export const DEFAULT_NOTIFICATION_SHOW_DURATION_SEC = 3;
export const TABLE_PAGING_VALUES = [10, 20, 50];
export const FIRST_PAGE_INDEX = 0;
export const PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 100;
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} HH:mm`;
export const MINIMAL_PASSWORD_LENGTH = 8;
export const SAVE_FILTERS_DEBOUNCE_TIMEOUT_MS = 5000;
export const TYPE_INPUT_DEBOUNCE_TIMEOUT_MS = 500;
export const FILTERS_DEBOUNCE_TIMEOUT_MS = 200;
export const AUTO_SAVE_INPUT_DEBOUNCE_TIMEOUT_MS = 1000;
export const FALLBACK_VALUE = '-';
export const SORT_BY_CREATED_DATE = 'createdDate';
export const LANGUAGE_LEVEL_SPLITTER = ' - ';
export const SECTION_ROW_GUTTER = [16, 16] as [Gutter, Gutter];
export const MIN_SEARCH_LENGTH = 3;

export const SWITCH_OPTIONS: {
  ['YES']: TranslationKey;
  ['NO']: TranslationKey;
  ['ALL']: TranslationKey;
} = {
  YES: 'common.yes',
  NO: 'common.no',
  ALL: 'common.all'
};
export const MAX_ITEMS_TO_GET = 10000;
export const QR_CODE_DEFAULT_DIMENSIONS = { width: 152, height: 152 };
export const NOTIFICATIONS_CHECK_DELAY_SEC = 30;
export const INIT_DATE_LOCAL_STORAGE_ITEM_NAME = 'CW_initDate';
export const USER_NAME_LOCAL_STORAGE_KEY = 'userName';
export const FALLBACK_NUMBER_VALUE = 0;
export const MAX_EMAIL_SEND_ATTEMPTS_COUNT = 5;
export const SEND_EMAIL_INTERVAL = 60;
export const ONE_SECOND_IN_MILLISECONDS = 1000;
export const FIELD_LOCKED_TOOLTIP =
  'tiers.label.thisFieldCannotBeEditedAfterJobCreation';
export const JOB_LOCKED_TOOLTIP = 'tiers.label.editingDisabled';

export const INITIAL_USER_CONFIG: User = {
  email: '',
  id: '',
  name: '',
  phone: '',
  status: '',
  selectedClient: '',
  twoFactor: false,
  attachments: [],
  clients: {},
  clientTierConfiguration: {
    tier: null,
    availableModules: [],
    applicationFilters: [],
    jobFilters: [],
    jobseekerFilters: [],
    applicationSortingOptions: [],
    jobSortingOptions: [],
    jobseekerSortingOptions: []
  },
  dismissGuide: false,
  jobsGuideCompleted: false,
  applicationsGuideCompleted: false,
  jobseekersGuideCompleted: false
};

export const UPGRADE_TIER_TOOLTIP = 'tiers.label.upgradeToTooltip';
export const AVAILABLE_ONLY_FOR_UPGRADED_JOBS_TOOLTIP =
  'tiers.label.availableOnlyForUpgradedJobs';

/**
 * @attention
 *
 * Check if needed to be translate
 */
export const CLIENT_TIER_NAMES = {
  [ClientTiers.Free]: 'Free',
  [ClientTiers.Basic]: 'Basic',
  [ClientTiers.Paid]: 'Paid',
  [ClientTiers.Enterprise]: 'Enterprise',
  [ClientTiers.Concierge]: 'Concierge'
};

export const DEFAULT_FILTERS: Partial<Filters> = {
  searchTerm: '',
  page: 0,
  pageSize: 10
};

export const MODULE_DEFAULT_SORT: Record<
  AppModules,
  { sortField: string; order: SortOrders }
> = {
  [AppModules.Jobseekers]: {
    sortField: 'verified',
    order: SortOrders.Desc
  },
  [AppModules.Jobs]: {
    sortField: 'createdDate',
    order: SortOrders.Desc
  },
  [AppModules.Clients]: {
    sortField: 'name',
    order: SortOrders.Asc
  },
  [AppModules.Applications]: {
    sortField: 'createdDate',
    order: SortOrders.Desc
  },
  [AppModules.Ace]: {
    sortField: 'startDate',
    order: SortOrders.Desc
  },
  [AppModules.Attachments]: {
    sortField: 'fileName',
    order: SortOrders.Asc
  },
  [AppModules.RecruitmentOverviewReport]: {
    sortField: 'createdDate',
    order: SortOrders.Asc
  }
};

export const MAX_SIDEBAR_WORK_EXPERIENCE_ITEMS_TO_SHOW = 3;
export const MAX_SIDEBAR_EDUCATION_ITEMS_TO_SHOW = 3;

export const DEBOUNCE_JOBS_TIMEOUT_MS = 3000;

export const COPIED_TO_CLIPBOARD_NOTIFICATION_TEXT: TranslationKey =
  'common.copied';
export const COPIED_TO_CLIPBOARD_NOTIFICATION_DURATION_MS = 2000;
export const JOBSEEKER_AVATAR_SIZE_PX = 86;

export const OBJECT_URL_REVOKE_DELAY_MS = 3_000;
export const DASHBOARD_CARDS_NUMBERS_SPLIT_SYMBOL = '’';
export const MAX_DASHBOARD_JOBS_TO_SHOW = 5;
